module.exports = __webpack_public_path__ + "img/ar-logo-text.c2a2b5aa.svg";